import React, { useCallback } from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'

import * as S from './styles'
import { graphql } from 'gatsby'
import { lintrk } from 'utils/helpers'
import { sendMatomoEvent } from '../../../tracking/matomo'
import { gaEvent } from '../../../tracking/analytics'

const Contact = ({ contact }) => {
  const { t } = useTranslation('common')

  const trackMail = useCallback(() => {
    try {
      gaEvent({
        category: 'Email Adress',
        action: 'Click on Email Adress',
      })
      sendMatomoEvent('Email Adress', 'Click on Email Adress')
      lintrk('track', { conversion_id: 6036348 })
    } catch (e) {}
  }, [])
  const trackNumber = useCallback(() => {
    try {
      gaEvent({
        category: 'Phone Number',
        action: 'Click on Phone Number',
      })
      sendMatomoEvent('Phone Number', 'Click on Phone Number')
      lintrk('track', { conversion_id: 6036356 })
    } catch (e) {}
  }, [])

  if (!contact) return null

  const { firstName, lastName, title, phone, linkedin, email, image } = contact

  return (
    <S.Contact>
      <S.Row>
        <S.ImgCol>
          {image.gatsbyImageData && (
            <S.Img
              gatsbyImageData={image.gatsbyImageData}
              square
              style={{ objectFit: 'contain' }}
              alt={image.alt?.localized ?? t('contactTitle')}
            />
          )}
        </S.ImgCol>
        <S.InfoCol>
          <S.Header>
            <span className="h2">{t('contactTitle')}</span>
            <span className="h3">{`${firstName} ${lastName}`}</span>
            <span className="h6">{title}</span>
          </S.Header>
          <ul>
            {email && (
              <li>
                <span>Email</span>
                <a href={`mailto: ${email}`} onClick={trackMail}>
                  {email}
                </a>
              </li>
            )}
            {phone && (
              <li>
                <span>Phone</span>
                <a href={`tel: ${phone}`} onClick={trackNumber}>
                  {phone}
                </a>
              </li>
            )}
            {linkedin && (
              <li>
                <a rel="noreferrer" target="_blank" href={linkedin}>
                  LinkedIn
                </a>
              </li>
            )}
          </ul>
        </S.InfoCol>
      </S.Row>
    </S.Contact>
  )
}

export default Contact

export const query = graphql`
  fragment ContactFragment on SanityContact {
    id
    firstName
    lastName
    title
    email
    linkedin
    phone
    image {
      alt {
        localized(locale: $language)
      }
      gatsbyImageData(
        width: 165
        height: 165
        aspectRatio: 1
        fit: CROP
        layout: FIXED
      )
    }
  }
`
